<template lang="pug">
  transition(name="fade")
    .Popup(
      v-shortkey="['esc']"
      @shortkey="close"
      @click="popupClose")

      transition(name="slide")
        .content(v-if="PAGE_SHOW")

          .header

            button.cancel(
              type="button"
              @click="close()")
              IconClose

            h3.title.u-text-width-bold
              | {{ $t('generic.action._order', [$t('generic.field.tag.s')]) }}

          .body
            .row
              .col.col-full
                .Form-item-label {{$t('generic.field.tag.p')}}
                Draggable(
                  v-model="orderedTags"
                  :options="{ animation: 120, draggable: '.handle'}"
                )
                  .tag-order.handle(v-for="tag in orderedTags")
                    .drag-handle
                      IconDragDots
                    span
                      | {{ tag.name }}

          .footer
            button.cancel.btn.btn-line(
              type="button"
              @click="close()"
            ) {{ $t('generic.action.cancel') }}

            button.save.btn.btn-primary(
              type="button"
              @click="save"
              :disabled="is_loading")
              Loading(v-if="is_loading")
              span(v-else) {{ $t('generic.action.save') }}

</template>

<script>
  import {mapActions, mapState} from 'vuex'
  import _cloneDeep from 'lodash/cloneDeep'
  import Draggable from 'vuedraggable'
  import _forEach from 'lodash/forEach'
  import _orderBy from 'lodash/orderBy'

  export default {
    name: 'TagOrder',
    components: {
      Draggable
    },

    data() {
      return {
        PAGE_SHOW: false,
        orderedTags: null
      }
    },

    created() {
      this.orderedTags = _cloneDeep(this.tag_list.list)
      this.orderedTags = _orderBy(this.orderedTags, 'order')
    },

    computed: {
      ...mapState('Tag', [
        'tag_list'
      ]),

      is_loading () {
        return this.$wait.is("updateTagOrders")
      }
    },

    methods: {

      ...mapActions('Tag', [
        'updateTagOrders'
      ]),

      popupClose(event) {
        if (event.target.classList.contains('Popup')) {
          this.close()
        }
      },

      close() {
        this.$router.push({
          name: 'tag'
        })
      },

      save() {
        this.$validator.validateAll().then(result => {
          if (!result) return

          _forEach(this.orderedTags, (value, i) => {
            value.order = i + 1
          })

          this.updateTagOrders({
            item: this.orderedTags
          })
              .then(res => {
                this.close()
              })
              .catch(err => {
                this.showErrorToast(this.$getErrorMessage(this, err))
              })
        })
      }
    },

    beforeRouteEnter(to, from, next) {
      next(vm => {
        setTimeout(() => {
          vm.PAGE_SHOW = true
        }, 0)
      })
    },

    beforeRouteLeave(to, from, next) {
      this.PAGE_SHOW = false
      setTimeout(() => {
        next()
      }, 150)
    }

  }
</script>


<style lang="scss" scoped>
  .tag-order {
    display: flex;
    align-items: center;
    padding-right: 70px;
    margin-bottom: 10px;
    height: $finger-size;
    background-color: #f6f8fa;
    border: 1px solid $color-shadow;
    border-radius: $border-radius;
    width: 100%;
    cursor: pointer;

    .drag-handle {
      color: $color-gray;

      .icon {
        height: 22px;
      }
    }
  }
</style>
